import React from 'react';
import { Link } from 'react-router-dom';
import VideoCard from './VideoCard';

const products = [
  {
    code: 'RX-PR01',
    name: 'Demulsificante para Crudo (Soluble en Agua)',
    description: 'Formulado para la separación rápida de agua en crudos pesados y medianos. Alta eficiencia a bajas temperaturas.',
    icon: 'ri-water-flash-line',
    video: 'https://rixingroup.cn/wp-content/uploads/2023/05/PR-01%E7%A0%B4%E4%B9%B3%E5%89%82%E8%87%AA%E5%BB%BA%E7%AB%99%E8%A7%86%E9%A2%91.mp4',
    poster: 'https://rixingroup.cn/wp-content/uploads/2023/05/PR01-scaled.jpg',
  },
  {
    code: 'RX-PR02',
    name: 'Demulsificante para Crudo (Soluble en Aceite)',
    description: 'Versión soluble en aceite para crudos con alto contenido de parafinas y asfaltenos. Compatibilidad superior.',
    icon: 'ri-oil-line',
    video: 'https://rixingroup.cn/wp-content/uploads/2023/06/%E8%87%AA%E5%BB%BA%E7%AB%99PR-02-1.mp4',
    poster: 'https://rixingroup.cn/wp-content/uploads/2023/06/PR02-scaled.jpg',
  },
  {
    code: 'RX-209',
    name: 'Inhibidor de Corrosión para Fluido de Perforación',
    description: 'Protege las tuberías y equipos contra la corrosión en condiciones de perforación agresivas.',
    icon: 'ri-shield-flash-line',
    video: 'https://rixingroup.cn/wp-content/uploads/2023/05/rx-209%E8%87%AA%E5%BB%BA%E7%AB%99.mp4',
    poster: 'https://rixingroup.cn/wp-content/uploads/2023/05/209%E5%89%AF%E6%9C%AC-scaled.jpg',
  },
  {
    code: 'RX-401',
    name: 'Imidazolina Soluble en Aceite',
    description: 'Compuesto activo multifuncional con propiedades anticorrosivas y tensioactivas para sistemas petroleros.',
    icon: 'ri-flask-line',
    video: 'https://rixingroup.cn/wp-content/uploads/2023/05/401%E8%87%AA%E5%BB%BA%E7%AB%99%E5%B1%95%E7%A4%BA%E8%A7%86%E9%A2%91.mp4',
    poster: 'https://rixingroup.cn/wp-content/uploads/2023/05/401%E5%89%AF%E6%9C%AC-scaled.jpg',
  },
  {
    code: 'RX-111',
    name: 'Depresor de Punto de Fluidez',
    description: 'Reduce el punto de fluidez del crudo para facilitar su transporte en climas fríos.',
    icon: 'ri-temp-cold-line',
    video: 'https://rixingroup.cn/wp-content/uploads/2023/05/RX-111%E8%87%AA%E5%BB%BA%E7%AB%99%E8%A7%86%E9%A2%91.mp4',
    poster: 'https://rixingroup.cn/wp-content/uploads/2023/05/111%E5%89%AF%E6%9C%AC-scaled.jpg',
  },
  {
    code: 'RX-716',
    name: 'Rhamnolípido (Biosurfactante)',
    description: 'Surfactante biológico de alta eficiencia, biodegradable y compatible con sistemas sensibles ambientalmente.',
    icon: 'ri-plant-line',
    video: 'https://rixingroup.cn/wp-content/uploads/2023/06/%E8%87%AA%E5%BB%BA%E7%AB%99RX-716-1.mp4',
    poster: 'https://rixingroup.cn/wp-content/uploads/2023/06/rx-716-scaled.jpg',
  },
];

export default function RixinProducts() {
  return (
    <section className="bg-background-100 py-20 md:py-28 border-t border-background-200/60">
      <div className="w-full px-4 md:px-8 lg:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-14 md:mb-18">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-6">
              <i className="ri-flask-line text-sm w-4 h-4 flex items-center justify-center" />
              Línea de Productos
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
              Portafolio de Productos <span className="text-primary-500">Rixin Group</span>
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
              Rixin Group produce más de 40 tipos de productos químicos especializados para la industria petrolera.
              En Venezuela, <strong>RESINVENCA RESINAS DE VENEZUELA C.A.</strong> distribuye oficialmente sus demulsificantes ya formulados.
            </p>
          </div>

          {/* Product Videos Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mb-12 md:mb-14">
            {products.map((product, index) => {
              const isDemulsifier = index < 2;
              return (
                <div key={product.code} className="relative">
                  {isDemulsifier && (
                    <div className="absolute -top-3 left-4 z-10 px-3 py-1 rounded-full bg-primary-500 text-background-50 text-[10px] font-bold uppercase tracking-wider">
                      Distribuido por RESINVENCA
                    </div>
                  )}
                  <VideoCard
                    src={product.video}
                    poster={product.poster}
                    title={product.code}
                    subtitle={product.name}
                    aspectRatio="square"
                  />
                  <div className="mt-3 px-1">
                    <p className="text-foreground-500 text-xs leading-relaxed">{product.description}</p>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Demulsifier highlight CTA */}
          <div className="bg-primary-500/10 rounded-lg p-8 md:p-10 border border-primary-200/40">
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
              <div>
                <h3 className="font-heading text-xl md:text-2xl font-bold text-primary-700 mb-2">
                  Demulsificante Rixin — Ya Formulado, Listo para Usar
                </h3>
                <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-xl">
                  RESINVENCA RESINAS DE VENEZUELA C.A. importa directamente desde las plantas de Rixin Group en China.
                  El producto llega a Venezuela formulado, certificado y empacado. Sin procesos adicionales,
                  sin diluciones: listo para aplicar en sus campos petroleros desde el primer día.
                </p>
              </div>
              <Link
                to="/productos"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25 flex-shrink-0"
              >
                Ver Producto RESINVENCA
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}